/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} The_Digital_VaultInputs */

const en_the_digital_vault = /** @type {(inputs: The_Digital_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Digital Vault`)
};

/** @type {(inputs: The_Digital_VaultInputs) => LocalizedString} */
const es_the_digital_vault = en_the_digital_vault;

/** @type {(inputs: The_Digital_VaultInputs) => LocalizedString} */
const fr_the_digital_vault = en_the_digital_vault;

/** @type {(inputs: The_Digital_VaultInputs) => LocalizedString} */
const de_the_digital_vault = en_the_digital_vault;

/** @type {(inputs: The_Digital_VaultInputs) => LocalizedString} */
const ja_the_digital_vault = en_the_digital_vault;

/** @type {(inputs: The_Digital_VaultInputs) => LocalizedString} */
const zh_the_digital_vault = en_the_digital_vault;

/** @type {(inputs: The_Digital_VaultInputs) => LocalizedString} */
const ar_the_digital_vault = en_the_digital_vault;

/** @type {(inputs: The_Digital_VaultInputs) => LocalizedString} */
const id_the_digital_vault = en_the_digital_vault;

/** @type {(inputs: The_Digital_VaultInputs) => LocalizedString} */
const it_the_digital_vault = en_the_digital_vault;

/** @type {(inputs: The_Digital_VaultInputs) => LocalizedString} */
const ru_the_digital_vault = en_the_digital_vault;

/** @type {(inputs: The_Digital_VaultInputs) => LocalizedString} */
const pt_the_digital_vault = en_the_digital_vault;

/** @type {(inputs: The_Digital_VaultInputs) => LocalizedString} */
const ko_the_digital_vault = en_the_digital_vault;

/**
* | output |
* | --- |
* | "The Digital Vault" |
*
* @param {The_Digital_VaultInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const the_digital_vault = /** @type {((inputs?: The_Digital_VaultInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<The_Digital_VaultInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_the_digital_vault(inputs)
	if (locale === "es") return es_the_digital_vault(inputs)
	if (locale === "fr") return fr_the_digital_vault(inputs)
	if (locale === "de") return de_the_digital_vault(inputs)
	if (locale === "ja") return ja_the_digital_vault(inputs)
	if (locale === "zh") return zh_the_digital_vault(inputs)
	if (locale === "ar") return ar_the_digital_vault(inputs)
	if (locale === "id") return id_the_digital_vault(inputs)
	if (locale === "it") return it_the_digital_vault(inputs)
	if (locale === "ru") return ru_the_digital_vault(inputs)
	if (locale === "pt") return pt_the_digital_vault(inputs)
	return ko_the_digital_vault(inputs)
});